/* Golfstore — YouTube-embeds in de omschrijvingstabbladen.

   Waarom dit bestaat: een iframe in een verborgen tabblad krijgt bij het laden
   geen afmetingen. YouTube kiest posterbeeld én streamkwaliteit op dat moment,
   dus je krijgt de laagste variant — en dat corrigeert hij niet als je later
   naar dat tabblad wisselt. Vandaar dat we de embed vervangen door een eigen
   voorbeeldweergave: een scherpe poster met afspeelknop, en pas bij klikken
   wordt de speler geladen, op volle breedte en in beeld.

   Bijvangst: geen YouTube-scripts en -cookies tot iemand daadwerkelijk speelt. */
(function () {
  'use strict';

  function videoId(src) {
    var m = src.match(/youtube(?:-nocookie)?\.com\/embed\/([A-Za-z0-9_-]{6,})/);
    if (m) return m[1];
    m = src.match(/[?&]v=([A-Za-z0-9_-]{6,})/);
    if (m) return m[1];
    m = src.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/);
    return m ? m[1] : null;
  }

  function facade(iframe) {
    var src = iframe.getAttribute('src') || '';
    var id = videoId(src);
    if (!id) return;

    var title = iframe.getAttribute('title') || 'Video';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gs-yt';
    btn.setAttribute('aria-label', title + ' afspelen');

    var img = document.createElement('img');
    img.className = 'gs-yt__poster';
    img.alt = '';
    img.loading = 'lazy';
    img.src = 'https://i.ytimg.com/vi/' + id + '/maxresdefault.jpg';
    /* Niet elke video heeft een maxres-poster; dan terugvallen op hq. */
    img.addEventListener('error', function () {
      if (img.getAttribute('data-fallback')) return;
      img.setAttribute('data-fallback', '1');
      img.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
    });

    var play = document.createElement('span');
    play.className = 'gs-yt__play';
    play.setAttribute('aria-hidden', 'true');

    btn.appendChild(img);
    btn.appendChild(play);

    btn.addEventListener('click', function () {
      var frame = document.createElement('iframe');
      frame.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
      frame.title = title;
      frame.className = 'gs-yt__frame';
      frame.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      frame.setAttribute('allowfullscreen', '');
      frame.setAttribute('loading', 'eager');
      btn.parentNode.replaceChild(frame, btn);
      frame.focus();
    });

    iframe.parentNode.replaceChild(btn, iframe);
  }

  function run(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(
      root.querySelectorAll('.gs-dtabs__body iframe[src*="youtube"], .gs-dtabs__body iframe[src*="youtu.be"]'),
      facade
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
